import { REPLICATION_SIZE } from '../../../utils/constants';
import {
  auditFields,
  buildReplication,
  getMutationIsActive,
  getMutationNestedValue,
  getMutationStringValue
} from '../utils';

/**
 * Pull builder for delivery confirmation data
 *
 * @param {*} db RxDB database
 */
const pullBuilder = (doc) => {
  const where = doc ? `lastmodifiedAt_Gt: "${doc.lastmodifiedAt}"` : '';

  const query = `{
    listDeliveryConfirmations(
      limit: ${REPLICATION_SIZE}
      offset: 0
      ordering: "lastmodifiedAt,ASC"
      ${where}
    ) {
      results {
        id
        icode

        type
        details

        task { id icode }

        ${auditFields}
      }
    }
  }`;

  return { query, variables: {} };
};

/**
 * Push builder for delivery confirmation data
 *
 * @param {*} db RxDB database
 */
const pushBuilder = (doc) => {
  const query = `
    mutation {
      upsertDeliveryConfirmation(
        input: {
          ${getMutationStringValue(doc, 'id')}
          ${getMutationStringValue(doc, 'type')}
          ${getMutationStringValue(doc, 'details')}

          ${getMutationNestedValue(doc, 'task')}

          ${getMutationIsActive(doc)}
        }
      ) {
        id
      }
    }
  `;

  return { query, variables: {} };
};

/**
 * Synchronize delivery confirmation data with GraphQL endpoint
 */
export const syncDeliveryConfirmation = (...args) => {
  return buildReplication(
    ...args,
    'deliveryConfirmation',
    { pullBuilder, pullQuery: 'listDeliveryConfirmations' },
    { pushBuilder }
  );
};
